import { render } from "./Receive.vue?vue&type=template&id=b898c8de&scoped=true"
import script from "./Receive.vue?vue&type=script&lang=js"
export * from "./Receive.vue?vue&type=script&lang=js"

import "./Receive.vue?vue&type=style&index=0&id=b898c8de&scoped=true&lang=css"
import "@/assets/css/Balances.css?vue&type=style&index=1&id=b898c8de&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b898c8de"]])

export default __exports__